/* NP Product Grid behaviors: per-card gallery arrows + quick-add to cart */
(function () {
  'use strict';

  function initGallery(gallery) {
    if (gallery.dataset.npInit) return;
    gallery.dataset.npInit = '1';
    var track = gallery.querySelector('[data-np-track]');
    var slides = track ? track.querySelectorAll('.np-card__slide') : [];
    var prev = gallery.querySelector('[data-np-prev]');
    var next = gallery.querySelector('[data-np-next]');
    var index = 0;
    gallery.dataset.index = '0';
    if (!track || slides.length < 2) return;

    function render() {
      // hover slide is absolutely positioned at index 0; skip it while sliding
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      gallery.dataset.index = String(index);
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= slides.length - 1;
    }

    function go(delta, e) {
      e.preventDefault();
      e.stopPropagation();
      var max = slides.length - 1;
      index = Math.min(max, Math.max(0, index + delta));
      render();
    }

    if (prev) prev.addEventListener('click', go.bind(null, -1));
    if (next) next.addEventListener('click', go.bind(null, 1));
    render();
  }

  function refreshCartUI() {
    // Try Dawn's cart drawer / notification section rendering
    var cartIcon = document.getElementById('cart-icon-bubble');
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('np:cart:updated', { detail: cart }));
        // update Dawn cart icon bubble by re-fetching its section
        fetch(window.location.pathname + '?sections=cart-icon-bubble')
          .then(function (r) { return r.json(); })
          .then(function (sections) {
            if (sections['cart-icon-bubble'] && cartIcon) {
              var div = document.createElement('div');
              div.innerHTML = sections['cart-icon-bubble'];
              var fresh = div.querySelector('#shopify-section-cart-icon-bubble') || div.firstElementChild;
              if (fresh) cartIcon.innerHTML = fresh.innerHTML;
            }
            // NP header cart count
            document.querySelectorAll('[data-np-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.closest('[data-np-cart]') && el.closest('[data-np-cart]').classList.toggle('np-cart-empty', cart.item_count === 0);
            });
          })
          .catch(function () {});
      })
      .catch(function () {});
  }

  function quickAdd(btn) {
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var id = btn.getAttribute('data-np-add');
    var body = { items: [{ id: Number(id), quantity: 1 }] };

    // Ask for drawer sections so Dawn's cart drawer updates if present
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      } catch (e) {}
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        btn.classList.remove('is-loading');
        if (response.status && response.status !== 200) return;
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function' && response.sections) {
          cartDrawer.renderContents(response);
        }
        refreshCartUI();
      })
      .catch(function () {
        btn.classList.remove('is-loading');
      });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-np-gallery]').forEach(initGallery);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-np-add]');
    if (btn) {
      e.preventDefault();
      quickAdd(btn);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
